import { TaskTodo } from 'crono-fe-common/types/cronoTaskTodo';
import { CronoErrorCode } from 'crono-fe-common/types/enums/cronoErrorCode';
import { TaskTodoType } from 'crono-fe-common/types/enums/taskTodoType';

//Mirrors TaskAutomationConstants.EmailErrorsRequiringUserAction in CronoModelModule
const emailErrorsRequiringUserAction = new Set<CronoErrorCode>([
  CronoErrorCode.AutomationFailedAddressMissing,
  CronoErrorCode.AutomationFailedTemplateMissing,
  CronoErrorCode.AutomationFailedEmailSettingsMissing,
  CronoErrorCode.AutomationFailedTemplateApplicationError,
  CronoErrorCode.AutomationFailedEmailNotValid,
  CronoErrorCode.AutomationFailedEmailFormatNotValid,
  CronoErrorCode.AutomationFailedProspectNotActive,
  CronoErrorCode.AutomationFailedAccountNotActive,
  CronoErrorCode.AutomationFailedProspectNotAssigned,
  CronoErrorCode.AutomationFailedMaxSendEmailLimit,
  CronoErrorCode.AutomationFailedThreadNotFound,
  CronoErrorCode.NoMailBoxConnected,
  CronoErrorCode.MailBoxNotPresent,
  CronoErrorCode.MailBoxDisconnected,
]);

//BE switches a task to manual on these errors and the nightly alignment re-automates it keeping the error,
//so on an automatic task they are stale. Any other error is transient: the task stays automatic and is retried.
const isErrorCleared = (
  task: Pick<TaskTodo, 'type' | 'automationError'>,
  error: CronoErrorCode,
) =>
  error === CronoErrorCode.AutomationFailedPreviousTaskPending ||
  task.type === TaskTodoType.LINKEDIN ||
  (task.type === TaskTodoType.EMAIL &&
    emailErrorsRequiringUserAction.has(error));

export const getVisibleAutomationError = (
  task: Pick<TaskTodo, 'type' | 'automatic' | 'automationError'>,
) => {
  const error = task.automationError ?? null;
  if (!error || (task.automatic && isErrorCleared(task, error))) return null;
  return error;
};

export const hasVisibleTaskError = (
  task: Pick<TaskTodo, 'type' | 'automatic' | 'automationError' | 'taskError'>,
) => Boolean(task.taskError || getVisibleAutomationError(task));
